<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { resolvePostLoginPath } from '@/composables/useLoginRedirect'
import { useAuth } from '@/composables/useAuth'

definePage({
  meta: {
    guest: true,
  },
})

const route = useRoute()
const router = useRouter()
const auth = useAuth()

const login = ref('')
const senha = ref('')
const loading = ref(false)

onMounted(() => {
  if (route.query.expired === '1') {
    void Swal.fire({
      icon: 'info',
      title: 'Sessão expirada',
      text: 'Faça login novamente para continuar.',
    })
  }
})

async function onSubmit(): Promise<void> {
  const loginValue = login.value.trim()
  const senhaValue = senha.value

  if (loginValue === '' || senhaValue === '') {
    await Swal.fire({
      icon: 'warning',
      title: 'Campos obrigatórios',
      text: 'Informe login e senha.',
    })
    return
  }

  loading.value = true

  try {
    await auth.login({
      login: loginValue,
      senha: senhaValue,
    })

    const usuario = auth.usuario.value
    if (!usuario) {
      throw new Error('Resposta de login inválida')
    }

    await router.replace(resolvePostLoginPath(usuario.tipo, route.query.redirect))
  } catch (error) {
    await Swal.fire({
      icon: 'error',
      title: 'Não foi possível entrar',
      text: auth.getErrorMessage(error, 'Credenciais inválidas'),
    })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <AuthLayout>
    <div class="card shadow-sm border-0">
      <div class="card-body p-4">

        <form @submit.prevent="onSubmit">
          <div class="mb-3">
            <label class="form-label" for="login">Usuário</label>
            <input
              id="login"
              v-model="login"
              type="text"
              class="form-control form-control-lg"
              autocomplete="username"
              :disabled="loading"
              required
            >
          </div>

          <div class="mb-4">
            <label class="form-label" for="senha">Senha</label>
            <input
              id="senha"
              v-model="senha"
              type="password"
              class="form-control form-control-lg"
              autocomplete="current-password"
              :disabled="loading"
              required
            >
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-lg w-100"
            :disabled="loading"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
            {{ loading ? 'Entrando…' : 'Entrar' }}
          </button>
        </form>
      </div>
    </div>
  </AuthLayout>
</template>
